import * as React from "react"
import { cn } from "@/lib/utils"

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          // Inputs sit firmly on the page: 4px radius, hairline rule, gold-soft focus ring.
          "flex h-11 w-full rounded-sm border border-rule bg-[rgba(255,252,244,0.7)] px-4 py-2 font-sans text-[14px] text-ink ring-offset-background transition placeholder:text-ink-soft/70 focus-visible:outline-none focus-visible:border-ink-soft focus-visible:ring-2 focus-visible:ring-gold-soft focus-visible:ring-offset-1 disabled:cursor-not-allowed disabled:opacity-50 file:border-0 file:bg-transparent file:text-sm file:font-medium",
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
